import { styled, Button } from '@material-ui/core';

const ActionButton = styled(Button)({
  minHeight: 65,
  fontSize: 34,
  whiteSpace: 'normal',
  wordWrap: 'break-word',
  display: 'flex',
  justifyContent: 'space-between',
});

export default ActionButton;
